import { render, staticRenderFns } from "./Sms.vue?vue&type=template&id=b2af46e8&scoped=true&"
import script from "./Sms.vue?vue&type=script&lang=js&"
export * from "./Sms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2af46e8",
  null
  
)

export default component.exports